/* eslint-disable filenames/match-exported */
import { fromJS } from 'immutable';
import { combineImmutableReducers } from '../util';
import ACTIONS from './actions';
// const DEFAULT_MAP = new Map();
// const DEFAULT_LIST = new List();

export const ContactFormStatusReducer = (state = null, action) => {
  switch (action.type) {
  case ACTIONS.SUBMIT_CONTACT_FORM:
    return 'submitting';
  case ACTIONS.CONTACT_FORM_SUCCESS:
    return 'success';
  case ACTIONS.CONTACT_FORM_FAILED:
    return 'failed';
  default:
    return state;
  }
};

export const ContactFormErrorMessageReducer = (state = null, action) => {
  switch (action.type) {
  case ACTIONS.CONTACT_FORM_FAILED:
    return action.error.response.data.errors.map(e => e.message); // fromJS(action).getIn(['error', 'response', 'data', 'message']);
  default:
    return state;
  }
};

const HubSpotFormReducer = combineImmutableReducers({
  contactFormStatus: ContactFormStatusReducer,
  contactFormErrorMessage: ContactFormErrorMessageReducer,
});

export default HubSpotFormReducer;

// Selectors
export const getContactFormStatus = state => state.get('contactFormStatus');
export const getContactFormErrorMessage = state => state.get('contactFormErrorMessage');



// WEBPACK FOOTER //
// ./src/hub_spot_form/reducer.js